import React from "react";
import { dressCode, golfEvents, siteImages } from "../data/redlandGolfContent";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import {
  Breadcrumbs,
  Card,
  EventCard,
  PageHero,
  PolicyAlert,
  SectionHeading,
  TextBlock,
} from "../components/RedlandComponents";

export default function GolfEvents() {
  const { events, contact } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Golf Events" />
      <PageHero
        eyebrow="Play, Compete, and Connect"
        title={golfEvents.title}
        copy={golfEvents.intro}
        image={siteImages.golfDetail}
        badge="Serving Great Golf Since 1947"
        tags={["Tournaments", "Leagues", "Junior Clinic", "Pro Shop"]}
        metaTitle="Call for Details"
        metaItems={["305-247-8503", "Extension 1", "Dress code required"]}
        actions={<ButtonLink href={contact.phoneHref}>Call the Pro Shop</ButtonLink>}
      />
      <section className="section">
        <div className="container">
          <PolicyAlert title="Gift Card Notice">{golfEvents.giftCardNotice}</PolicyAlert>
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Club Championship Winners" />
          <div className="card-grid three">
            {golfEvents.winners.map((winner) => (
              <Card className="winner-card" key={winner.title}>
                <span className="winner-mark" aria-hidden="true">
                  |
                </span>
                <p>{winner.title}</p>
                <h3>{winner.name}</h3>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <SectionHeading title="Activities and Events" />
          <div className="card-grid three">
            {events.map((event) => (
              <EventCard key={event.title} {...event} />
            ))}
          </div>
        </div>
      </section>
      <section className="section section-cream">
        <div className="container card-grid two">
          <Card className="featured-event">
            <p className="eyebrow">Featured Event</p>
            <h2>{golfEvents.clinic.title}</h2>
            <ul className="clean-list">
              {golfEvents.clinic.details.map((detail) => (
                <li key={detail}>{detail}</li>
              ))}
            </ul>
          </Card>
          <Card>
            <h2>Pro Shop and Rental Information</h2>
            <ul className="clean-list">
              {golfEvents.proShop.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Card>
        </div>
      </section>
      <section className="section">
        <div className="container card-grid two">
          <PolicyAlert title="Dress Code" tone="green">
            <ul className="clean-list">
              {dressCode.slice(0, 4).map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </PolicyAlert>
          <Card>
            <h2>Updates</h2>
            <TextBlock text={golfEvents.checkBack} />
          </Card>
        </div>
      </section>
    </>
  );
}
